import * as Yup from 'yup';

export const dealValidationSchema = Yup.object().shape({
  financeConditionItem: Yup.object().shape({
    contractDate: Yup.string().required('Contract Date is required'),
    daysToFirstPayment: Yup.number().required('Days to first payment is required'),
    firstPaymentDate: Yup.string().required('First Payment Date is required'),
    totalSalesTaxPercentage: Yup.string().required('Sales Tax is required'),
  }),
});

export const dealCalcErrorSchema = Yup.object().shape({
  estimatedScore: Yup.number()
    .test('maxDigits', 'Estimated Score must be less than or equal to 3', (value) => {
      if (!value) return true;

      const stringValue = String(value);

      return stringValue.length <= 3;
    })
    .required(),
});

export const flagshipOverrideValidation = Yup.object().shape({
  comment: Yup.string().nullable().required(),
  originalLoanAmount: Yup.number().nullable().required(),
});
